import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import i18n from "../../helpers/i18n";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  FIXED_HEADER_BG,
  IS_BACK_CLICKED,
  SELECTED_LANG,
} from "../../services/common/Constants";
import { BuildPath, QUERY_ACCOUNT } from "../../services/common/endpoints";
import {
  GetCacheKey,
  getItemOfSessionStorage,
  setItem,
  setItemInSessionStorage,
} from "../../services/common/utils";
import { useTranslation } from "react-i18next";
import { useIdleTimer } from "react-idle-timer";
import {
  resetUserData,
  setSelectedMenu,
  setSelectedMenuPrev,
  setcustomerprofile,
  setrnuserdetails,
  setNotificationsArray,
  setQueryAccountData,
  setLangrx
} from "../../reducer/actions";
import { useQuery } from "react-query";
import {
  EndPointUserDetails,
  LOGOUT_API,
} from "../../services/common/endpoints";
import SidebarModal from "../sidebar/sidebar-modal";
import { GTM_Logout, GTM_ChangeLanguage } from "../../analytics/GoogleTagManager";
import WifiHeader from "../common/wifiheader";
import { RC4Decrypt } from "../../services/common/RC4EncDec";
import {CT_Events} from "../../analytics/CTEvents";
import BottomSlider from "../common/bottom-slider";
import { getImgSrc } from "../../services/common/CommonUtils";
import { setLangInLocalStorage } from "../../services/common/CommonUtils";
import { resetCdrReduxData } from "../../reducer/cdrSlice";

// mapping ==> paytype: redirect-url
const BACK_REDIRECT = {
  'addons': '/addonshome',
  'bundles': '/bundles',
  'roamingdeals': '/roaming',
  'mycountry': '/mycountryhome'
}

const faqImage_en = "/assets/images/assist_icon.png";
const faqImage_ar = "/assets/images/assist_icon_ar.png";

const HeaderComponent = ({ type, name, color, showBack,icon, isShareIcon=false, setShareIconAction }) => {
  const x = getItemOfSessionStorage(SELECTED_LANG);
  const css1 = localStorage.getItem("css1");
  const css2 = localStorage.getItem("css2");
  const dispatch = useDispatch();
  const [iconFlag, setIconFlag] = useState(false)
  const [showBottomModal, setShowBottomModal] = useState(false);
  const [enableLogoutApi, setenableLogoutApi] = useState(false);
  const [selectednumber, setSelectedNumber] = useState("");
  const [selectedlang, setSelectedLang] = useState(
    x !== null && x !== "" && x !== undefined ? x : "en"
  );
  const [showBottomSlider, setShowBottomSlider] = useState(false);
  //const selectedMsisdn = "241414124124";
  const tokenid = useSelector((state) => state.userdata.value.tokenid);
  let langrx = useSelector((state) => state?.userdata?.value?.langrx);
  const selectedMsisdn = useSelector(
    (state) => state.userdata.value.selectedmsisdn
  );
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const {CT_Logout, CT_ChangeLanguage} = CT_Events();
  const {
    userdata: { headerTitleColor, isDefaultCarouselBanner },
  } = useSelector((state) => state);
  
    const paciLogin = useSelector(
    (state) => state.userdata.value.isPaciLogin
  );

  const queryAccountParams =   paciLogin === false ?'{"type":"msisdn_manage", "responseinlegacy":"1","ml":"T"}' : '{\"type\":\"msisdn_manage\", \"responseinlegacy\":\"1\", \"ml\":\"T\",  \"skipisprimay\" : \"T\" }';

  const typesNotToCallQuryAccount = [15]; 
  const isQueryAccount = !typesNotToCallQuryAccount.includes(type);

  useQuery(["lines-list", QUERY_ACCOUNT, JSON.parse(queryAccountParams), {}, true], {
    retry: false,
    retryOnMount: true,
    enabled: isQueryAccount,
    onSuccess: ({data}) => {
      dispatch(setQueryAccountData(data));
    }
  });

  // const { queryAccountData } = useSelector((state) => state.userdata);

  const logout = () => {
    let _lang = getItemOfSessionStorage(SELECTED_LANG);
    dispatch(resetUserData());
    setenableLogoutApi(true);
    sessionStorage.clear();
    try{
      var _savedLogin = localStorage.getItem("sl");
      localStorage.clear();
      if(_savedLogin != null && _savedLogin != undefined && _savedLogin != ""
      && _savedLogin != "undefined"){
       localStorage.setItem("sl",_savedLogin)
      }
       }catch{}
    setItem(SELECTED_LANG, _lang);
    try{
      GTM_Logout("Dashboard", selectedMsisdn, logintype, "Success");
      CT_Logout();
    }catch{}
    navigate("/#");
  };
  // const SelectedMenu = useSelector(
  //   (state) => state.userdata.value.SelectedMenu
  // );

  // const SelectedMenuPrev = useSelector(
  //   (state) => state.userdata.value.SelectedMenuPrev
  // );

  let ismanagelineopen = null;
  const {
    appData: { themeColor },
  } = useSelector((state) => state);
  //const [ismanagelineopen,setismanagelineopen] = useState("");
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);
  const [scroll, setScroll] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const bgcolor = sessionStorage.getItem("bgcolor");
  useEffect(() => {
    try {
      if (window.location.href.indexOf("manage-lines") > 0) {
        setItemInSessionStorage("ism", "true");
      } else {
        setItemInSessionStorage("ism", "false");
      }
    } catch {}

    let x = getItemOfSessionStorage(SELECTED_LANG);
    if (x !== null && x !== "" && x !== undefined) {
      x = x;
    } else {
      x = "en"
      // x = langrx ? langrx : "en"
    }
    // dispatch(setLangrx(x));
    setItem(SELECTED_LANG, x);
  }, []);
  
  useEffect(()=>{
    if(window.location.href?.includes("lang=") && queryParams?.get('lang')){
      if(queryParams?.get('lang') === 'en') {
        if(x === 'ar') {i18n.changeLanguage('en'); setItem(SELECTED_LANG, "en"); window.location.reload()}
        else{i18n.changeLanguage('en'); setItem(SELECTED_LANG, "en");}
      }else if(queryParams?.get('lang') === 'ar'){
        if(x === 'en'){i18n.changeLanguage('ar'); setItem(SELECTED_LANG, "ar"); window.location.reload()}
        else{i18n.changeLanguage('ar'); setItem(SELECTED_LANG, "ar");}
      }
    }
    else if(window.location.href?.match(/&en|&ar|\$en|\$ar/)){
      if(window.location.href?.match(/&en|\$en/)){
        if(  x === 'ar') { setItem(SELECTED_LANG, "en");i18n.changeLanguage('en'); window.location.reload() }
        else{ setItem(SELECTED_LANG, "en");i18n.changeLanguage('en');}
      }else if(window.location.href?.match(/&ar|\$ar/)){
        if( x === 'en'){ setItem(SELECTED_LANG, "ar"); i18n.changeLanguage('ar'); window.location.reload() }
        else{i18n.changeLanguage('ar'); setItem(SELECTED_LANG, "ar");}
      }
    }
  }, [])

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
    i18n.changeLanguage(getItemOfSessionStorage(SELECTED_LANG));
  }, [selectedlang]);

  useEffect(() => {
    if (selectedMsisdn) {
      setSelectedNumber(selectedMsisdn);
    }
  }, [selectedMsisdn]);

  const { data: { data } = {} } = useQuery(["", LOGOUT_API, {}, {}, false], {
    enabled: enableLogoutApi,
    retry: false,
  });
  const handleOnIdle = () => {
    let _lang = getItemOfSessionStorage(SELECTED_LANG);
    dispatch(resetUserData());
    dispatch(resetCdrReduxData());
    setenableLogoutApi(true);
    sessionStorage.clear();
    try{
     var _savedLogin = localStorage.getItem("sl")
     localStorage.clear();
     if(_savedLogin != null && _savedLogin != undefined && _savedLogin != ""
     && _savedLogin != "undefined"){
      localStorage.setItem("sl",_savedLogin)
     }
      }catch{}
    setItem(SELECTED_LANG, _lang);
    navigate("/#");
  };
  const { start } = useIdleTimer({
    startManually: true,
    timeout: 1.2e6,
    crossTab: true,
    syncTimers: 200,
    onIdle: () => handleOnIdle(),
  });
  useEffect(() => {
    if (tokenid) start();
  }, [tokenid]);

  // if (type === 1) {
  //   return (
  //     <header className={`header ${scroll ? "open" : ""}`}>
  //       <div className="header_container flex_grp_center">
  //         <div className="header_left">
  //           <button className="img_btn img_btn_lg btn_trigger" onClick={handleGoBack}>
  //             <img
  //               src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
  //               alt=""
  //               title=""
  //             />
  //           </button>
  //         </div>
  //         <div className="header_center">
  //           <h4 className="header_title">Login</h4>
  //         </div>
  //         <div className="header_actions flex_grp_align_center">
  //           <button className="language_change me-2">عربى</button>
  //           <button className="img_btn img_btn_lg">
  //             <img
  //               src={process.env.PUBLIC_URL + "/assets/images/assist_icon.png"}
  //               alt=""
  //               title=""
  //             />
  //           </button>
  //         </div>
  //       </div>
  //     </header>
  //   );
  // }
  // if (type === 2) {
  //   return (
  //     <header className={`header ${scroll ? "open" : ""}`}>
  //       <div className="header_container flex_grp_center">
  //         <div className="header_center">
  //           <a href="#/manage-lines" className="multi_account_drop">
  //             <span>{selectednumber}</span>
  //             <img
  //               src={
  //                 process.env.PUBLIC_URL +
  //                 "/assets/images/arrow_down_dark_sm.svg"
  //               }
  //               alt=""
  //               title=""
  //             />
  //           </a>
  //         </div>
  //         <div className="header_actions flex_grp_align_center">
  //           <button className="img_btn img_btn_lg btn_trigger">
  //             <div className="counter">22</div>
  //             <img
  //               src={process.env.PUBLIC_URL + "/assets/images/bell_dark.svg"}
  //               alt=""
  //               title=""
  //             />
  //           </button>
  //           <button className="img_btn img_btn_lg btn_trigger ms-2">
  //             <img
  //               src={process.env.PUBLIC_URL + "/assets/images/assist_icon.png"}
  //               alt=""
  //               title=""
  //             />
  //           </button>
  //         </div>
  //       </div>
  //     </header>
  //   );
  // }

  // if (type === 3) {
  //   return (
  //     <header className={`header ${scroll ? "open" : ""}`}>
  //       <div className="header_container flex_grp_center">
  //         <div className="header_left">
  //           <button className="img_btn img_btn_lg btn_trigger" onClick={handleGoBack}>
  //             <img
  //               src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
  //               alt=""
  //               title=""
  //             />
  //           </button>
  //         </div>
  //         <div className="header_center">
  //           <a className="multi_account_drop">
  //             <span>{selectednumber}</span>
  //             <img
  //               src={
  //                 process.env.PUBLIC_URL +
  //                 "/assets/images/arrow_down_dark_sm.svg"
  //               }
  //               alt=""
  //               title=""
  //             />
  //           </a>
  //         </div>
  //         <div className="header_actions flex_grp_align_center">
  //           <button className="img_btn img_btn_lg btn_trigger">
  //             <div className="counter">22</div>
  //             <img
  //               src={process.env.PUBLIC_URL + "/assets/images/bell_dark.svg"}
  //               alt=""
  //               title=""
  //             />
  //           </button>
  //           <button className="img_btn img_btn_lg btn_trigger ms-2">
  //             <img
  //               src={process.env.PUBLIC_URL + "/assets/images/assist_icon.png"}
  //               alt=""
  //               title=""
  //             />
  //           </button>
  //         </div>
  //       </div>
  //     </header>
  //   );
  // }
  // if (type === 4) {
  //   return (
  //     <header className={`header ${scroll ? "open" : ""}`}>
  //       <div className="header_container flex_grp_center">
  //         <div className="header_left">
  //           <button className="img_btn img_btn_lg btn_trigger" onClick={handleGoBack}>
  //             <img
  //               src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
  //               alt=""
  //               title=""
  //             />
  //           </button>
  //         </div>
  //         <div className="header_center">
  //           <h4 className="header_title">Pay</h4>
  //         </div>
  //         <div className="header_actions flex_grp_align_center">
  //           <button className="img_btn img_btn_lg btn_trigger">
  //             <div className="counter">22</div>
  //             <img
  //               src={process.env.PUBLIC_URL + "/assets/images/bell_dark.svg"}
  //               alt=""
  //               title=""
  //             />
  //           </button>
  //           <button className="img_btn img_btn_lg btn_trigger ms-2">
  //             <img
  //               src={process.env.PUBLIC_URL + "/assets/images/assist_icon.png"}
  //               alt=""
  //               title=""
  //             />
  //           </button>
  //         </div>
  //       </div>
  //     </header>
  //   );
  // }

  const ClickToPage = (lnk) => {
    try {
      navigate("/" + lnk);
    } catch (e) {}
  };

  const pathString = location?.pathname?.split("/")[1];
  let urlParam = '';
  let paytype = '';
  let fromPage = '';
  if(pathString === 'shared-offer-details'){
    urlParam = RC4Decrypt(params?.offerid);
    const searchParams = new URLSearchParams(urlParam);
    paytype = searchParams.get('paytype');
    fromPage = searchParams.get('from');
  }

  const searchParams = new URLSearchParams(location?.search);
  const backcallback = searchParams.get('backcallback');

  const [scrolling, setScrolling] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);

  // useEffect(() => {
  //   let x = document.querySelector(".header");
  //   function onScroll() {
  //     let currentPosition = window.pageYOffset; // or use document.documentElement.scrollTop;
  //     if (currentPosition > scrollTop) {
  //       // downscroll code
  //       // x.style.position = "relative";
  //       x.setAttribute("id", "scrollUp")
  //       setScrolling(false);

  //     } else {
  //       // upscroll code
  //       // x.style.position = "sticky";
  //       x.setAttribute("id", "scrollDown")
  //       setScrolling(true);
  //     }
  //     setScrollTop(currentPosition <= 0 ? 0 : currentPosition);
  //   }

  //   window.addEventListener("scroll", onScroll);
  //   return () => window.removeEventListener("scroll", onScroll);
  // }, [scrollTop]);

  //theme-header
  useEffect(() => {
    var prevScrollpos = window.pageYOffset;
window.onscroll = function() {
var currentScrollPos = window.pageYOffset;
  if (prevScrollpos >= currentScrollPos) {
    if(document.getElementById("theme-header")){
      document.getElementById("theme-header").style.top = "0";
    }
  } else {
    if(document.getElementById("theme-header")){
      document.getElementById("theme-header").style.top = "-60px";
    }
  }
  prevScrollpos = currentScrollPos;
}
  }, []);


  const handleGoBack = () => {
        if(pathString === 'shared-offer-details' && fromPage !== 'recentpurchase'){
      let url = `${BACK_REDIRECT[paytype]}?backcallback=home` ?? '/home'
      navigate(url, {
        replace: true
      });
      return;
    }

    if(backcallback){
      navigate(backcallback, {
        replace: true
      });
      return;
    }

    if(location.pathname === '/manage-account'){
      navigate('/home');
    }else if(location.pathname === "/paci-civilid"){
      navigate('/')
    }else if(location.pathname === '/ooredoo-pedia'){
      navigate('/support', {replace: true});
    }else if(location.pathname === '/call-details'){
      navigate('/manage-account', {replace: true});
    }else{
      setItemInSessionStorage(IS_BACK_CLICKED, "true");
      //dispatch(setSelectedMenu(SelectedMenuPrev));
      navigate(-1);
    }
  };

  window.onclick = (e) => {
    const isBackClicked = e?.target?.id === 'back_image';
    const el = document.getElementsByClassName('slidein-transition')[0];
    const isHistroyStack = window?.history?.length > 2;
    
    console.log("window.location.length==>", window.history.length)

    if(location.pathname === '/ooredoo-pedia'){
      if(isBackClicked && el){
        el.classList.add('slidein-from-' + 'left-long');
      }
    }else{
      if(isBackClicked && el && isHistroyStack){
        el.classList.add('slidein-from-' + 'left');
      }
    }
  }

  useEffect(() => {
    setTimeout(() => {
    const el = document.getElementsByClassName('slidein-transition')[0];
    el.classList.remove('slidein-from-' + 'right');
    el.classList.remove('slidein-from-' + 'left');
    el.classList.remove('slidein-from-' + 'left-long');
    }, 300)
  }, [location])

  const handleHelpclick = () => {
    // navigate("/help-home");
    dispatch(setSelectedMenu("/home/index"));
    navigate("/support");
  };

  const handleManageLines = (e) => {
    //dispatch(setSelectedMenu("home/index"));
    //dispatch(setSelectedMenuPrev(SelectedMenu));
    if (window.location.href.indexOf("manage-lines") > 0) {
      setItemInSessionStorage("ism", "false");
      // navigate(-1);
      navigate("/home");
    } else {
      setItemInSessionStorage("ism", "true");
      // navigate("/manage-lines");
      e.preventDefault();
      setShowBottomSlider(true);
    }

   
  };

  const languagechangeclick = () => {
    document.documentElement.lang = getItemOfSessionStorage(SELECTED_LANG);
    dispatch(setNotificationsArray("clearNotification"));

    try{
      if(window.location.href.indexOf("?lang=") > 0) {
        window.location.href = window.location.href.split("?lang=")[0];
      }
    }catch{}
    if((queryParams?.get('lang') && window.location.href?.includes("lang=")) || window.location.href?.match(/&en|&ar|\$en|\$ar/) ){
      let url = getItemOfSessionStorage(SELECTED_LANG) === 'en' ? window.location.href?.slice(0,-2) + 'ar': window.location.href?.slice(0,-2)+ "en"
      setSelectedLang(getItemOfSessionStorage(SELECTED_LANG) === 'en' ? 'ar' : 'en');
      setItem(SELECTED_LANG, getItemOfSessionStorage(SELECTED_LANG) === 'en' ? 'ar' : 'en');

      window.location.href= url;
      window.location.reload();
    }
    else if (
      selectedlang != null &&
      selectedlang != undefined &&
      selectedlang != "" &&
      selectedlang == "en"
    ) {
      //alert("setting arabic lang in session")
      setSelectedLang("ar");
      // dispatch(setLangrx('ar'));
      // setLangInLocalStorage('ar');
      setItem(SELECTED_LANG, "ar");
      //window.history.replaceState(null, "", window.location.href.replace('/en', '/ar'));
      try{
        GTM_ChangeLanguage(logintype);
        CT_ChangeLanguage("Arabic");
      }catch{}
      window.location.reload();
      
    } else {
      //alert("setting english lang in session")
      setSelectedLang("en");
      // dispatch(setLangrx('en'));
      // setLangInLocalStorage('en');
      setItem(SELECTED_LANG, "en");
      //window.history.replaceState(null, "", window.location.href.replace('/ar', '/en'));
      try{
        GTM_ChangeLanguage(logintype);
        CT_ChangeLanguage("English");
      }catch{}
      window.location.reload();
    }
  };
  //   const rnuserdetails = useQuery(
  //     [
  //       GetCacheKey("GET_RN_USER_DETAILS"),
  //       EndPointUserDetails.url,
  //       EndPointUserDetails.data,
  //       {},
  //     ],
  //     {
  //       retry: false,
  //       retryOnMount: true,
  //     }
  //   );

  //   const userDetailsApi = useQuery(
  //     [
  //       GetCacheKey("GET_USER_DETAILS"),
  //       "customerprofile/get",
  //       { source: "homepage", sec: "splash" },
  //       {},
  //     ],
  //     {
  //       retry: false,
  //       retryOnMount: true,
  //     }
  //   );
  //   useEffect(() => {
  //     if (userDetailsApi.isSuccess && userDetailsApi?.data?.data) {
  //       dispatch(setcustomerprofile(userDetailsApi?.data?.data?.response));
  //     }
  //     if (rnuserdetails.isSuccess && rnuserdetails?.data?.data) {
  //       dispatch(setrnuserdetails(rnuserdetails?.data?.data?.response));
  //       try {
  //         let _msisdn = "";
  //         if (
  //           rnuserdetails?.data?.data?.response?.msisdn &&
  //           rnuserdetails?.data?.data?.response?.msisdn.length == 11
  //         )
  //           _msisdn = rnuserdetails?.data?.data?.response?.msisdn.slice(3);
  //         else _msisdn = rnuserdetails?.data?.data?.response?.msisdn;

  //         dispatch(setSelectedNumber(_msisdn));
  //       } catch (e) {}
  //     }
  //   }, [
  //     userDetailsApi?.data?.data,
  //     userDetailsApi.isSuccess,
  //     rnuserdetails?.data?.data,
  //     rnuserdetails.isSuccess,
  //   ]);

  const toggleBottomSlider = () => {
    setShowBottomSlider(preVal => !preVal);
  }

  const faqIcon = selectedlang === 'ar' ? faqImage_ar : faqImage_en;

  if (type === 1) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center">
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            <h4 className="header_title">{t("login")}</h4>
          </div>
          <div className="header_actions flex_grp_align_center">
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button className="img_btn img_btn_lg" onClick={handleHelpclick}>
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }
  if (type === 2) {

    const isHomePage = location.pathname == "/home/index" || location.pathname == "/home";

    // let textColor = '';
    let arrowImage = '/assets/images/arrow_down_dark_sm.svg';
    // let faqImage = "/assets/images/assist_icon.png";

    // if(isHomePage){
    //   if(isDefaultCarouselBanner){
    //     textColor = ''
    //   }else{
    //     textColor = headerTitleColor;
    //   }
    // }else {
    //   textColor = ''
    // }

    // if(isHomePage && headerTitleColor?.toUpperCase() === '#FFFFFF'){
    //   arrowImage = '/assets/images/arrow_down_white.svg';
    //   faqImage = '/assets/images/faq_white.svg';
    // }

    let textColor = '';
    if(isHomePage){
      textColor = headerTitleColor || '';
    }

    return (
      <>
      <header id={isHomePage ? 'theme-header' : ''} className={`header ${scroll ? "open" : ""}`}>
      {iconFlag ? <WifiHeader setIconFlag={setIconFlag} iconFlag ={iconFlag} logout = {logout} /> :   <div
          className="header_container flex_grp_center"
          style={{ background: FIXED_HEADER_BG ? FIXED_HEADER_BG : color }}
        >
            <div className="header_left header_left_ar wifi-header-img">
            {icon && 
            <button
              className="img_btn img_btn_lg btn_trigger"    
              onClick={() => setIconFlag(!iconFlag)}       
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/wifi_blue_icon.svg"}
                alt=""
                title=""
              />
            </button>
              }
          </div>
          <div className="header_center">
            <a onClick={handleManageLines} className="multi_account_drop" 
              style={{ color: textColor }}
            >
              <span>{selectednumber}</span>
              {/* <div className="uparrow-iconsp16">
              
              </div> */}
              {/* <img
                // style={{
                //   transform:
                //     getItemOfSessionStorage("ism") == "true"
                //       ? "rotate(180deg)"
                //       : "none",
                // }}
                src={
                  process.env.PUBLIC_URL +
                  arrowImage
                }
                alt=""
                title=""
              /> */}
              <div className="sp16mt3">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" style={{stroke: textColor || '#000'}}>
    <path
      fill="none"
      //stroke="#005871"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m1.414 1.414 6 6 6-6"
      data-name="chevron-down"
    />
  </svg>
  </div>



            </a>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} alt="" title="" />
                    </button> */}
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
              style={{ color: textColor }}
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              {/* <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              /> */}

              <svg xmlns="http://www.w3.org/2000/svg" className="help-icon" style={{ stroke: textColor || '#000'}}>
    <circle
      cx={10}
      cy={10}
      r={10}
      fill="none"
      //stroke="#172b4d"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      data-name="Ellipse 351"
      transform="translate(1 1)"
    />
    <path
      fill="none"
      //stroke="#172b4d"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.09 8a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
      data-name="Path 465"
    />
    <path
      fill="none"
      //stroke="#172b4d"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11 16h0"
      data-name="Line 25"
    />
  </svg>
              
            </button>
          </div>
        </div>}
      </header>

      <BottomSlider show={showBottomSlider} title='Switch your line' message='You can set or update your primary number from here' toggleModal={toggleBottomSlider} />
      </>
    );
  }

  if (type === 3) {
    return (
      <>
      <header className={`header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center" style={{ backgroundColor: FIXED_HEADER_BG ? FIXED_HEADER_BG : themeColor }}>
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            <a onClick={handleManageLines} className="multi_account_drop">
              <span>{selectednumber}</span>
              <img
                // style={{
                //   transform:
                //     getItemOfSessionStorage("ism") == "true"
                //       ? "rotate(180deg)"
                //       : "none",
                // }}
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/arrow_down_dark_sm.svg"
                }
                alt=""
                title=""
              />
            </a>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} 
                        alt="" title="" />
                    </button> */}

            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>

            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>

      <BottomSlider show={showBottomSlider} title='Switch your line' message='You can set or update your primary number from here' toggleModal={toggleBottomSlider} />
      </>
    );
  }
  if (type === 4) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center">
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            <h4 className="header_title">{t("pay")}</h4>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} alt="" title="" />
                    </button> */}
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }
  if (type === 5) {
    return (
      <>
      <header className={`header white_header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center">
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            {name ? (
              <h4 className="header_title">{t(name)}</h4>
            ) : (
              <a onClick={handleManageLines} className="multi_account_drop">
                <span>{selectednumber}</span>
                <img
                  // style={{
                  //   transform:
                  //     getItemOfSessionStorage("ism") == "true"
                  //       ? "rotate(180deg)"
                  //       : "none",
                  // }}
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/arrow_down_dark_sm.svg"
                  }
                  alt=""
                  title=""
                />
              </a>
            )}
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} alt="" title="" />
                    </button> */}
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>

      <BottomSlider show={showBottomSlider} title='Switch your line' message='You can set or update your primary number from here' toggleModal={toggleBottomSlider} />
      </>
    );
  }

  if (type === 7) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center">
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            <h4 className="header_title">{t("ooredoosurprise")}</h4>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                            <div className="counter">22</div>
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/bell_dark.svg"}
                                alt=""
                                title=""
                            />
                        </button> */}

            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>

            <button
              className="img_btn img_btn_lg btn_trigger ms-2"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }

  if (type === 8) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center">
          <div className="header_left">
            {(tokenid !== null && tokenid?.length > 0) ||
            queryParams.get("headerText") ? (
              <button
                className="img_btn img_btn_lg btn_trigger"
                onClick={handleGoBack}
              >
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                  alt=""
                  title=""
                  id='back_image'
                />
              </button>
            ) : (
              ""
            )}
          </div>
          <div className="header_center">
            <h4 className="header_title dir-ltrl">
              {queryParams.get("headerText") || ""}
            </h4>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} alt="" title="" />
                    </button> */}
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }
  if (type === 9) {
    return (
      <header className={`header  `}>
        <div className="header_container flex_grp_center" style={{backgroundColor: color}}>
          <div className="header_left"></div>

          <div className="header_center">
            <h4 className="header_title"></h4>
          </div>

          <div className="header_actions flex_grp_align_center">
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>

            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }

  if (type === 10) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center">
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            <h4 className="header_title">{t("viewbill")}</h4>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} alt="" title="" />
                    </button> */}
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }

  if (type === 12) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center">
          <div className="header_center">
            {/* <h4 className="header_title">Verify Account</h4> */}
            {/* <button className="img_btn img_btn_lg btn_trigger ms-2" onClick={handleHelpclick}>
                        <img src={process.env.PUBLIC_URL + '/assets/images/logo_red.svg'} alt="" title="" />
                    </button> */}

            <div>
              <div class="side_menu_top">
                <div class="side_menu_logo">
                  <img
                    src={BuildPath + "/assets/images/logo_red.svg"}
                    alt=""
                    title=""
                  ></img>
                </div>
              </div>
            </div>
          </div>
          <div className="header_actions flex_grp_align_center">
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>

            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }

  if (type === 13) {
    const pageWithThemeHeader = [
      '/paybill',
    ];
    const showThemeHeader = pageWithThemeHeader.includes(location.pathname);
    // console.log(color, "colorrr")
    //location.pathname = "";
    return (
      <header id={showThemeHeader ? 'theme-header' : ''} className={`header ${scroll ? "open" : ""}`}>
        <div
          className="header_container flex_grp_center"
          style={{ background: FIXED_HEADER_BG ? FIXED_HEADER_BG : color }}
        >
          <div className="header_left">
            {/* <button
            className="img_btn img_btn_lg btn_trigger"
            onClick={handleGoBack}
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
              alt=""
              title=""
            />
          </button> */}
          </div>
          <div className="header_center">
            {console.log(
              window.location.hash.includes("#/moremenu"),
              "window.location.hash"
            )}
            <div>
              <div class="side_menu_top">
                <div class="side_menu_logo">
                  <img
                    src={getImgSrc('/assets/images/logo_red.svg')}
                    alt=""
                    title=""
                  ></img>
                </div>
              </div>
            </div>
          </div>
          <div className="header_actions flex_grp_align_center">
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className={"language_change"}
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>

            <button
              className={`img_btn img_btn_lg btn_trigger  ${
                window.location.hash === "#/moremenu"
                  ? "header-bg-btn-comp"
                  : ""
              }`}
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
       
        {/* </div> */}
      </header>
    );
  }

  if (type === 14) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center white_bg">
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            <h4 className="header_title dir-ltrl">
              {t(queryParams.get("headerText") || "")}
              {/* {queryParams.get("headerText") || ""} */}
            </h4>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                            <div className="counter">22</div>
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/bell_dark.svg"}
                                alt=""
                                title=""
                            />
                        </button> */}

            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>

            <button
              className="img_btn img_btn_lg btn_trigger "
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }

  // header with static text from translation based on location path
  if (type === 15) {
    const pathString = location?.pathname?.split("/")[1];

    const MAP_LOCATION_PATH_AND_HEADER_LABEL = {
      'help-status': t("requeststatus"),
      'nojoom-partners': t("partnerrewards"),
      'nojoom-partner': t("partnerrewards"),
      'nojoom-partner-detail': t("partnerrewards"),
      'earn-points': t("earnpoints"),
      'earn-points-partner-detail': t("earnpoints"),
      'nojoom-buypoints': t("buypoints"),
      'xpress-profit': t('xps_pft_heading'),
      'load-balance': t('xps_pft_heading'),
      'transfer-balance': t('xps_pft_heading'),
      'transfer-review': t('xps_pft_heading'),
      'internet-transfer': t('internet_transfer'), 
      'add-member': t('internet_transfer'),
      'manage-member': t('internet_transfer'), 
      'internet-transfer-review': t('internet_transfer'),
      'smart-pay-settings': t('smart_pay_page_heading'),
      'smart-pay-cards': t('Smart_Pay'),
      'smart-pay-edit-numbers': t('smart_pay_page_heading'),
      'smart-pay-edit-cards': t('edC'),
      'smart-pay-numbers': t('Smart_Pay'),
      'smart-pay-manage': t('smart_pay_page_heading'),
      'requestcredit' : t('request_credits'),
      'share-offer' : t('share_offer'),
      'manage-account' : t('manage_account'),

      // for sprint-16 components
      'sprint-16-components' : t('Sprint 16 Components'),

      // for more new pages
      'my-account' : t('my_account'),
      'my-payments' : t('my_payments'),
      'my-cards' : t('payment_method'),
      'terms-and-conditions' : t('terms_and_conditions'),
      'personal-info' : t('personal_info'),
      'password-management' : t('password_management'),
      'delete-account' : t('my_account'),
      'transaction-history' : t('transaction_history'),
      'transaction-detail' : t('transaction_history'),
      'payment-method' : t('payment_method'),

      //for support new pages
      'support' : t('support'),
      'help-articles-list' : t('help_articles'),
      'help-articles-list-detail' : t('help_articles'),
      'need-help-list' : t('need_help'),
      'network-and-internet-list' : t('net_internet'),
      'network-and-internet-list-detail' : t('net_internet'),
      'payments' : t('payments'),
      'your-bill' : t('your_bill'),
      'track-complaints' : t('track_complaints'),
      'ooredoo-pedia' : t('ooredoo_pedia'),

      //for call details pages
      'verification-otp': t('Verification'),
      'verification-paci': t('Verification'),
      'verification-confirmation': t('Verification'),
      'choose': t('Choose'),
      'call-details': t('Call Details'),
      'verification': t('Verification')
    }

    const showBgColor = (pathString !== 'help-status' && pathString !== 'xpress-profit' && pathString !== 'load-balance' && pathString !== 'transfer-balance' && pathString !== 'transfer-review' && pathString !== 'internet-transfer' && pathString !== 'add-member' && pathString !== 'manage-member' && pathString !== 'internet-transfer-review' && pathString !== 'smart-pay-settings' && pathString !== 'smart-pay-cards' && pathString !== 'smart-pay-edit-numbers' && pathString !== 'smart-pay-edit-cards' && pathString !== 'smart-pay-numbers' && pathString !== 'smart-pay-manage' && pathString !== 'requestcredit') && pathString !== 'share-offer' ? true : false;

    let bgColor = "";
    let textColor = "";
    let faqImage = "";
    let backImage = "";

    switch (pathString) {
      case "nojoom-partners":
      case "nojoom-partner":
      case "nojoom-partner-detail":
      case "earn-points":
      case "earn-points-partner-detail":
        bgColor = "#ed1c24";
        textColor = FIXED_HEADER_BG ? '' : "#ffffff";
        faqImage = FIXED_HEADER_BG ? faqIcon : "/assets/images/faq_white.svg";
        backImage = FIXED_HEADER_BG ? '/assets/images/back_dark.svg' : "/assets/images/back_white.svg";
        break;
      case "share-offer":
      case "support":
        backImage = '/assets/images/cross_dark.svg';
        break;
      default:
        bgColor = themeColor;
        faqImage = faqIcon;
        backImage = "/assets/images/back_dark.svg";
    }

    const pagesWithoutLangIcon = [
      "/share-offer",
    ];
    const pagesWithoutHelpIcon = [
      "/share-offer",
    ];
    const hideLangIcon = pagesWithoutLangIcon.includes(location.pathname);
    const hideHelpIcon = pagesWithoutHelpIcon.includes(location.pathname);


    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div
          className="header_container flex_grp_center"
          style={{ backgroundColor: FIXED_HEADER_BG ? FIXED_HEADER_BG : showBgColor ? bgColor : "" }}
        >
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img src={process.env.PUBLIC_URL + backImage} alt="" title="" id='back_image' />
            </button>
          </div>
          <div className="header_center">
            <h4
              className="header_title"
              style={{ color: showBgColor ? textColor : "" }}
            >
              {MAP_LOCATION_PATH_AND_HEADER_LABEL[pathString] || ""}
            </h4>
          </div>
          <div className="header_actions flex_grp_align_center">
            {isShareIcon &&
              <button className="language_change" id="shareIcon" onClick={()=>{setShareIconAction(true)}}>
                <img src={process.env.PUBLIC_URL + '/assets/images/shareIcon.svg'}/>
              </button>
            }
            {
              !hideLangIcon && (
                <button
                  onClick={() => languagechangeclick()}
                  id="langbtn"
                  className="language_change"
                  style={{ color: showBgColor ? textColor : "" }}
                >
                  {selectedlang !== "en" ? "English" : "عربى"}
                </button>
              )
            }

            {
              !hideHelpIcon && (
                <button
                  className="img_btn img_btn_lg btn_trigger"
                  onClick={handleHelpclick}
                >
                  <img src={process.env.PUBLIC_URL + faqImage} alt="" title="" />
                </button>
              )
            }
          </div>
        </div>
      </header>
    );
  }
  if (type === 16) {
    const pageWithThemeHeader = [
      '/paybill',
      '/more',
    ];
    const showThemeHeader = pageWithThemeHeader.includes(location.pathname);
    return (
      <>
  <header id={showThemeHeader ? 'theme-header' : ''} className={`header ${scroll ? "open" : ""}`}>
  {iconFlag ? <WifiHeader setIconFlag={setIconFlag} iconFlag ={iconFlag} logout = {logout} /> : <div
          className="header_container flex_grp_center" 
          style={{ background: FIXED_HEADER_BG ? FIXED_HEADER_BG : color }}
        >      
          <div className="header_left header_left_ar wifi-header-img">
            {icon && 
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={() => setIconFlag(!iconFlag)}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/wifi_blue_icon.svg"}
                alt=""
                title=""
              />
            </button>
              }
          </div>
          <div className="header_center">
            <a onClick={handleManageLines} className="multi_account_drop">
              <span>{selectednumber}</span>
              <img
                // style={{
                //   transform:
                //     getItemOfSessionStorage("ism") == "true"
                //       ? "rotate(180deg)"
                //       : "none",
                // }}
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/arrow_down_dark_sm.svg"
                }
                alt=""
                title=""
              />
            </a>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} 
                        alt="" title="" />
                    </button> */}

            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>

            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>}
            <SidebarModal
        show={showBottomModal}
        toggleModal={() => { setShowBottomModal(!showBottomModal);}}
        logoutOk={logout}
      />
      </header> 

      <BottomSlider show={showBottomSlider} title='Switch your line' message='You can set or update your primary number from here' toggleModal={toggleBottomSlider} />
      </>
    );
  }
  if (type === 17) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center">
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            <h4 className="header_title">{t("voucher")}</h4>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} alt="" title="" />
                    </button> */}
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }
  if (type === 18) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center">
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            <h4 className="header_title">{t("account")}</h4>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} alt="" title="" />
                    </button> */}
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }
  if (type === 19) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div
          className="header_container flex_grp_center"
          style={{ background: FIXED_HEADER_BG ? FIXED_HEADER_BG : color }}
        >
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            <h4 className="header_title">{t("passportsingle")}</h4>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} alt="" title="" />
                    </button> */}
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }
  if (type === 20) {

    const pageName = name ? name : selectedMsisdn;

    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center"
          style={{ background: FIXED_HEADER_BG ? FIXED_HEADER_BG : '' }}
        >
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            {/* <h4 className="header_title">{t("passportsingle")}</h4> */}
            <h4 className="header_title">{pageName}</h4>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} alt="" title="" />
                    </button> */}
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }
  if (type === 21) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center" style={{ background: FIXED_HEADER_BG ? FIXED_HEADER_BG : '' }}>
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            <h4 className="header_title">{t("ooredooservices")}</h4>
          </div>
          <div className="header_actions flex_grp_align_center">
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }
  if (type === 22) {
    return (
      <>
      <header className={`header`}>
        <div className="header_container flex_grp_center red_bg" style={{ backgroundColor: FIXED_HEADER_BG ? FIXED_HEADER_BG : color }}>
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            <a
              onClick={handleManageLines}
              className="multi_account_drop"
            >
              <span>{selectednumber}</span>
              <img
                // style={{
                //   transform:
                //     getItemOfSessionStorage("ism") == "true"
                //       ? "rotate(180deg)"
                //       : "none",
                // }}
                src={
                  process.env.PUBLIC_URL + "/assets/images/arrow_down_dark_sm.svg"
                }
                alt=""
                title=""
              />
            </a>
          </div>
          <div className="header_actions flex_grp_align_center">
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>

      <BottomSlider show={showBottomSlider} title='Switch your line' message='You can set or update your primary number from here' toggleModal={toggleBottomSlider} />
      </>
    );
  }
  if (type === 23) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div
          className={`header_container flex_grp_center ${
            location.pathname === "/transfertopartner" ? "" : ""
          } )`}
          style={{ backgroundColor: FIXED_HEADER_BG ? FIXED_HEADER_BG : '' }}
        >
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            <h4 className="header_title">{t("transferpoints")}</h4>
          </div>
          <div className="header_actions flex_grp_align_center">
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }

  //transfer credit
  if (type === 24) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
      <div className="header_container flex_grp_center">
        <div className="header_left">
          <button
            className="img_btn img_btn_lg btn_trigger"
            onClick={handleGoBack}
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
              alt=""
              title=""
              id='back_image'
            />
          </button>
        </div>
        <div className="header_center">
          <h4 className="header_title">{t("transfercredit")}</h4>
        </div>
        <div className="header_actions flex_grp_align_center">
          {/* <button className="img_btn img_btn_lg btn_trigger">
                      <div className="counter">22</div>
                      <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} alt="" title="" />
                  </button> */}
          <button
            onClick={() => languagechangeclick()}
            id="langbtn"
            className="language_change"
          >
            {selectedlang !== "en" ? "English" : "عربى"}
          </button>
          <button
            className="img_btn img_btn_lg btn_trigger"
            onClick={handleHelpclick}
          >
            <img
              src={getImgSrc(faqIcon)}
              alt=""
              title=""
            />
          </button>
        </div>
      </div>
    </header>
    );
  }

  //esim
  if (type === 25) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
      <div className="header_container flex_grp_center">
        <div className="header_left">
          <button
            className="img_btn img_btn_lg btn_trigger"
            onClick={handleGoBack}
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
              alt=""
              title=""
              id='back_image'
            />
          </button>
        </div>
        <div className="header_center">
          <h4 className="header_title">{t("eSIM")}</h4>
        </div>
        <div className="header_actions flex_grp_align_center">
          {/* <button className="img_btn img_btn_lg btn_trigger">
                      <div className="counter">22</div>
                      <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} alt="" title="" />
                  </button> */}
          <button
            onClick={() => languagechangeclick()}
            id="langbtn"
            className="language_change"
          >
            {selectedlang !== "en" ? "English" : "عربى"}
          </button>
          <button
            className="img_btn img_btn_lg btn_trigger"
            onClick={handleHelpclick}
          >
            <img
              src={getImgSrc(faqIcon)}
              alt=""
              title=""
            />
          </button>
        </div>
      </div>
    </header>
    );
  }
  console.log(location.pathname, "location.pathname ")
  // header with number in middle (copy of type 2) with bgcolor
  if (type === "2A") {
    const isHomePage = location.pathname == "/home/index" || location.pathname == "/home";
    const isNojoomPage = location.pathname == "/nojoom";
    return (
      <>
      <header id={(isHomePage || isNojoomPage) ? 'theme-header' : ''} className={`header ${scroll ? "open" : ""}`}>
      {iconFlag && location.pathname === '/nojoom' ? <WifiHeader setIconFlag={setIconFlag} iconFlag ={iconFlag} logout = {logout} /> :    <div
          className="header_container flex_grp_center"
          style={{ backgroundColor: FIXED_HEADER_BG ? FIXED_HEADER_BG : themeColor }}
        >
          {
            showBack ? (
              <div className="header_left">
                <button
                  className="img_btn img_btn_lg btn_trigger"
                  onClick={handleGoBack}
                >
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                    alt=""
                    title=""
                    id='back_image'
                  />
                </button>
              </div>
            ) : (
              <></>
            )
          }
            <div className="header_left  header_left_ar wifi-header-img">
            {icon && 
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={() => setIconFlag(!iconFlag)}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/wifi_blue_icon.svg"}
                alt=""
                title=""
              />
            </button>
              }
          </div>
          <div className="header_center">
            <a onClick={handleManageLines} className="multi_account_drop">
              <span>{selectednumber}</span>
              <img
                // style={{
                //   transform:
                //     getItemOfSessionStorage("ism") == "true"
                //       ? "rotate(180deg)"
                //       : "none",
                // }}
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/arrow_down_dark_sm.svg"
                }
                alt=""
                title=""
              />
            </a>
          </div>
          <div className="header_actions flex_grp_align_center">
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>}
      </header>

      <BottomSlider show={showBottomSlider} title='Switch your line' message='You can set or update your primary number from here' toggleModal={toggleBottomSlider} />
      </>
    );
  }


  if (type === 26) {
    return (
      <>
      <header className={`header ${scroll ? "open" : ""}`}>
        <div
          className="header_container flex_grp_center"
          style={{ background: FIXED_HEADER_BG ? FIXED_HEADER_BG : themeColor }}
        >
<div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>

          <div className="header_center">
            <a onClick={handleManageLines} className="multi_account_drop">
              <span>{selectednumber}</span>
              <img
                // style={{
                //   transform:
                //     getItemOfSessionStorage("ism") == "true"
                //       ? "rotate(180deg)"
                //       : "none",
                // }}
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/arrow_down_dark_sm.svg"
                }
                alt=""
                title=""
              />
            </a>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} alt="" title="" />
                    </button> */}
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>

      <BottomSlider show={showBottomSlider} title='Switch your line' message='You can set or update your primary number from here' toggleModal={toggleBottomSlider} />
      </>
    );
  }
  if (type === 27) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div
          className="header_container flex_grp_center"
          style={{ background: FIXED_HEADER_BG ? FIXED_HEADER_BG : color }}
        >
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} alt="" title="" />
                    </button> */}
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }
  if (type === 29) {
    return (
      <header className={`header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center">
          <div className="header_left">
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            <h4 className="header_title">{t("all_promotions")}</h4>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} alt="" title="" />
                    </button> */}
            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>
            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>
    );
  }

  //recent transactions
  if (type === 28) {
    return (
      <>
      <header className={`header ${scroll ? "open" : ""}`}>
        <div className="header_container flex_grp_center" 
        style={{backgroundColor : FIXED_HEADER_BG ? FIXED_HEADER_BG : themeColor}}
        >
          <div className="header_left">
          <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleGoBack}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/back_dark.svg"}
                alt=""
                title=""
                id='back_image'
              />
            </button>
          </div>
          <div className="header_center">
            <a onClick={handleManageLines} className="multi_account_drop">
              <span>{selectednumber}</span>
              <img
                // style={{
                //   transform:
                //     getItemOfSessionStorage("ism") == "true"
                //       ? "rotate(180deg)"
                //       : "none",
                // }}
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/arrow_down_dark_sm.svg"
                }
                alt=""
                title=""
              />
            </a>
          </div>
          <div className="header_actions flex_grp_align_center">
            {/* <button className="img_btn img_btn_lg btn_trigger">
                        <div className="counter">22</div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/bell_dark.svg'} 
                        alt="" title="" />
                    </button> */}

            <button
              onClick={() => languagechangeclick()}
              id="langbtn"
              className="language_change"
            >
              {selectedlang !== "en" ? "English" : "عربى"}
            </button>

            <button
              className="img_btn img_btn_lg btn_trigger"
              onClick={handleHelpclick}
            >
              <img
                src={getImgSrc(faqIcon)}
                alt=""
                title=""
              />
            </button>
          </div>
        </div>
      </header>

      <BottomSlider show={showBottomSlider} title='Switch your line' message='You can set or update your primary number from here' toggleModal={toggleBottomSlider} />
      </>
    );
  }

  return <div />;
};

export default HeaderComponent;
